<template>
  <div class="modal-duplicate-quote">
    <div class="modal-head">
      <h4>DUPLICATING QUOTE {{ quote.quote_number }}</h4>
    </div>

    <div class="modal-body">
      <div class="form-row">
        <label class="lb w150">Quote Number:</label>
        <div class="inputs">
          <div class="custom-control custom-radio">
            <input type="radio" id="quote-number-seq" v-model="quoteNumber" class="custom-control-input" value="seq">
            <label class="custom-control-label" for="quote-number-seq">Sequence (#{{ nextSequence }})</label>
          </div>
          <div class="custom-control custom-radio">
            <input type="radio" id="quote-number-new" v-model="quoteNumber" class="custom-control-input" value="new">
            <label class="custom-control-label" for="quote-number-new">New</label>
          </div>
        </div>
      </div>
      <div class="form-row" v-if="quote.job_id">
        <label class="lb w150">Job:</label>
        <div class="inputs">
          <div class="custom-control custom-radio">
            <input type="radio" id="job-number-new" v-model="jobNumber" class="custom-control-input" value="new">
            <label class="custom-control-label" for="job-number-new">New</label>
          </div>
          <div class="custom-control custom-radio">
            <input type="radio" id="job-number-none" v-model="jobNumber" class="custom-control-input" value="none">
            <label class="custom-control-label" for="job-number-none">None</label>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-foot">
      <div class="btns btns-2">
        <button type="button" class="btn btn-outline-black" @click="duplicateQuote">Duplicate</button>
        <button type="button" class="btn btn-outline-gray" @click="$emit('close')">Cancel</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ServiceQuote from '@/services/quote'

export default {
  data () {
    return {
      quoteNumber: 'seq',
      jobNumber: 'new',
      state: ''
    }
  },
  props: ['quote', 'on_job_view'],
  watch: {},
  computed: {
    ...mapState({
      sequenceCharacters: state => state.option.sequenceCharacters
    }),
    nextSequence: function(){
      let self = this, index = 0;
      if (self.quote.sequence) {
        index = self.sequenceCharacters.indexOf(self.quote.sequence) + 1;
      }
      return (self.quote.parent_id?self.quote.parent_id:self.quote.id) + self.sequenceCharacters[index];
    }
  },
  created () {},
  mounted () {},
  methods: {
    init () {

    },
    duplicateQuote () {
      let self = this;
      if ( self.state == 'processing' ) {
        return;
      }
      self.state = 'processing';
      ServiceQuote.clone({ id: self.quote.id, quoteNumber: self.quoteNumber, jobNumber: self.jobNumber }, quote => {
        self.state = '';
        self.$notify({
          type: 'success',
          text: 'This quote has been cloned. '
        });
        if (self.on_job_view) {
          self.$store.dispatch('ADD_JOB_QUOTE', quote);
        } else {
          if(self.jobNumber == 'new' && quote.job)
            self.$store.dispatch('ADD_QUOTE_JOB_DATA', quote.job);
          self.$router.push({
            name: 'quote',
            params: {
              quoteId: quote.id
            }
          });
        }
        self.$emit('close');
      });
    }
  }
}
</script>
